/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './drawer.stache';
import { getDiffClass } from 'components/right-rail/biggest-movers/line/line';
import dtm from 'scripts/services/dtm';
import _ from 'lodash';

Component.extend({
    tag: 'biggest-movers-drawer',
    template: template,
    viewModel: {
        define: {
            playerComparisonUrl: {
                get() {
                    return can.sub(
                        window.globalSettings.pagePaths.playerComparison,
                        {
                            player1: this.attr('player.identifier'),
                            player2: '',
                        },
                    );
                },
            },
            noData: {
                get() {
                    return !this.attr(`probability.playerPoints`);
                },
            },
            playerPageUrl: {
                get() {
                    return can.sub(window.globalSettings.pagePaths.player, {
                        playerId: this.attr('player.identifier'),
                    });
                },
            },
            startHole: {
                get() {
                    const round = this.attr('round');
                    let start = 1;
                    if (round) {
                        start = this.attr(
                            `player.roundsInfo.${round -
                                1}.scorecard.holeResults.0.hole.identifier`,
                        );
                    }
                    return start;
                },
            },
            probabilities: {
                type: 'object',
            },
            probabilityType: {
                type: 'string',
            },
            activeId: {
                type: 'string',
            },
            player: {
                type: 'object',
            },
            probability: {
                type: 'object',
            },
            position: {
                type: 'object',
            },
            processDisplayValue: {
                type: 'function',
            },
        },
        setActiveId(playerId) {
            if (this.attr('activeId') === playerId) {
                this.attr('activeId', null);
                return;
            }

            this.attr('activeId', playerId);
        },
        clickCompareEvent(event) {
            event.preventDefault();
            dtm.trackBiggestMoversPlayersCompareClick(
                `${this.attr('player.firstName')} ${this.attr(
                    'player.lastName',
                )}`,
            );

            window.open(this.attr('playerComparisonUrl'));
        },
        clickPlayerProfileEvent(event) {
            event.preventDefault();
            dtm.trackPlayerProfileClick(
                `${this.attr('player.firstName')} ${this.attr(
                    'player.lastName',
                )}`,
                'Biggest Movers',
            );

            window.open(this.attr('playerPageUrl'));
        },
        getDiffClass,
    },
    events: {
        inserted() {},
    },
});
